<template>
  <dl class="description-list grid-x grid-margin-x max-w-md">
    <template v-if="!isCreditMemo">
      <dt class="cell small-6" v-html="bp('textTrackingNumber')" />
      <dd class="cell small-6">
        <trek-link
          button
          text
          underline
          icon-right
          icon="launch"
          target="_blank"
          :href="shipmentData.tracking.shipmentTrackingUrl"
        >
          <span v-html="shipmentData.tracking.shipmentTrackingNumber" />
        </trek-link>
      </dd>

      <dt class="cell small-6" v-html="bp('textDeliveryMethod')" />
      <dd class="cell small-6" v-html="shipmentData.shipmentMethod" />

      <dt class="cell small-6" v-html="bp('testShipDate')" />
      <dd class="cell small-6" v-html="shipmentData.shipDate" />

      <dt class="cell small-6" v-html="bp('textShipToAddress')" />
      <dd class="cell small-6">
        <div v-show="shipmentData.shippingAddress.companyName" v-html="shipmentData.shippingAddress.companyName" />
        <div v-show="shipmentData.shippingAddress.line1" v-html="shipmentData.shippingAddress.line1" />
        <div v-show="shipmentData.shippingAddress.line2" v-html="shipmentData.shippingAddress.line2" />
        <div v-show="shipmentData.shippingAddress.line3" v-html="shipmentData.shippingAddress.line3" />
        <div v-show="shipmentData.shippingAddress.line4" v-html="shipmentData.shippingAddress.line4" />
        <span v-show="shipmentData.shippingAddress.town" v-html="shipmentData.shippingAddress.town" />,
        <span
          v-show="shipmentData.shippingAddress.region.isocodeShort"
          v-html="shipmentData.shippingAddress.region.isocodeShort"
        />
        <div v-show="shipmentData.shippingAddress.postalCode" v-html="shipmentData.shippingAddress.postalCode" />
        <span v-show="shipmentData.shippingAddress.region.countryIso" v-html="shipment.shipToCountry" />
      </dd>

      <dt class="cell small-6" v-html="bp('textWarehouse')" />
      <dd class="cell small-6" v-html="shipmentData.dc" />
    </template>
    <template v-if="shipmentData.packingSlip && shipmentData.packingListURL && !isCreditMemo">
      <dt class="cell small-6" v-html="bp('textPackingList')" />
      <dd class="cell small-6">
        <trek-link
          v-if="shipmentData.packingSlipAvailable"
          button
          text
          icon-right
          icon="insert_drive_file"
          :href="shipmentData.packingListURL"
        >
          <span v-html="shipmentData.packingSlip" />
        </trek-link>
        <span v-else v-html="shipmentData.packingSlip" />
      </dd>
    </template>
    <template v-if="shipmentData.invoices.length">
      <dt class="cell small-6" v-html="bp('textInvoice')" />
      <dd class="cell small-6">
        <div v-for="invoice in shipmentData.invoices" :key="invoice.invoiceNumber">
          <trek-link button text icon-right icon="insert_drive_file" :href="invoice.invoiceUrl">
            <span v-html="invoice.invoiceNumber" />
          </trek-link>
        </div>
      </dd>
    </template>
  </dl>
</template>

<script>
export default {
  props: {
    shipment: {
      type: Array,
      required: true,
      default: () => [],
    },
    orderData: {
      type: Object,
      required: true,
      default: () => {},
    },
    name: {
      type: String,
      default: '',
    },
    isCreditMemo: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {};
  },
  computed: {
    shipmentData() {
      let result = {};
      const tabName = this.name;
      this.orderData.consignments.forEach((el) => {
        if (el.code == tabName || this.isCreditMemo) {
          result = el;
        }
      });
      return result;
    },
  },
};
</script>
